import React, { useEffect } from "react";
import EmailEditor from "components/SendLetter/EmailEditor/EmailEditor";
import { CreateCampaignForm } from "../CreateCampaignForm/CreateCampaignForm";
import { Wrapper } from "./Theme";
import { SendEmail } from "../SendEmail/SendEmail";
import { useDispatch } from "react-redux";
import { setCardContent } from "services/api/communication";
import {
  setIsFromSelectedStep,
  setSelectedTemplate,setCreateCampaignDialog
} from "services/api/communication";
export const NewTemplate = ({
  formik,
  onNext,
  onBack,
  activeStep,
  setActiveStep,
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setIsFromSelectedStep(false));
  }, []);
  const renderContent = () => {
    switch (activeStep) {
      case 0:
        return (
          <CreateCampaignForm
            formik={formik}
            onNext={onNext}
            onBack={() => dispatch(setCardContent("Create Campaign"))}
          />
        );
      case 1:
        return (
          <EmailEditor
            withoutHeader
            dropDownTypes={true}
            setCampaignModal={() =>  dispatch(setCreateCampaignDialog(false))}
            buttonClassName="button_className"
            prevouis
            prevouisOnClick={onBack}
            onNext={onNext}
            setTemplate={(template) => dispatch(setSelectedTemplate(template))}
          />
        );
      case 2:
        return (
          <SendEmail
            formik={formik}
            onNext={onNext}
            onBack={onBack}
            isMultiple={false}
            setActiveStep={setActiveStep}
            step={1}
          />
        );

      default:
        return;
    }
  };

  return (
    <Wrapper margin={activeStep === 2 ? "10%" : activeStep === 0 && "20%"}>
      {renderContent()}
    </Wrapper>
  );
};
